import { getChecklistSeo } from "../seo/checklistSeo";
import { getChecklistSectionsWithItems } from "../data/buyerChecklistContent";

function resolveField(t, exists, key, fallback) {
  if (exists(key)) {
    return t(key);
  }
  return fallback;
}

export function getLocalizedChecklistSections(t, exists) {
  return getChecklistSectionsWithItems().map((section) => ({
    ...section,
    title: resolveField(
      t,
      exists,
      `automotive.buyerChecklist.sections.${section.id}.title`,
      section.title
    ),
    description: resolveField(
      t,
      exists,
      `automotive.buyerChecklist.sections.${section.id}.description`,
      section.description
    ),
    items: section.items.map((item) => ({
      ...item,
      title: resolveField(
        t,
        exists,
        `automotive.buyerChecklist.items.${item.id}.title`,
        item.title
      ),
      description: resolveField(
        t,
        exists,
        `automotive.buyerChecklist.items.${item.id}.description`,
        item.description
      ),
    })),
  }));
}

export function getBuyerChecklistImportanceLabel(t, exists, importance) {
  const fallbacks = {
    essential: "Esencial",
    recommended: "Recomendado",
    optional: "Opcional",
  };
  return resolveField(
    t,
    exists,
    `automotive.buyerChecklist.importance.${importance}`,
    fallbacks[importance] || importance
  );
}

export function getLocalizedChecklistSeo(t, exists, { hasVehicleQueryContext = false } = {}) {
  const base = getChecklistSeo({ hasVehicleQueryContext });
  const title = resolveField(
    t,
    exists,
    "automotive.buyerChecklist.seo.title",
    "Checklist para comprar carro usado en Colombia"
  );
  const description = resolveField(
    t,
    exists,
    "automotive.buyerChecklist.seo.description",
    base.description
  );

  return {
    ...base,
    title,
    description,
    openGraph: {
      ...base.openGraph,
      title,
      description,
    },
    twitter: {
      ...base.twitter,
      title,
      description,
    },
  };
}

export function getLocalizedChecklistSummaryFallback(t, exists) {
  return resolveField(
    t,
    exists,
    "automotive.buyerChecklist.generalSummary",
    "Checklist general para comprar carro usado"
  );
}
